import { GlobalFormConfigType } from './types'

const globalConfig: GlobalFormConfigType = {
  regex: {
    leiWrite: /^[ a-zA-Z0-9&_\-.()]{0,10}$/g,
    lei: /^[A-Z0-9]{4}0{2}[A-Z0-9]{12}\d{2}$/g,
    number: /^[0-9]+$/g,
    numberGreaterThanZero: /^[1-9]\d*$/g,
    percentage: /^([0-9]|[1-9][0-9]|100)$/g,
    telephone: /(^\+?([ \d]{0,21})$)|(^[ \d]{0,22}$)/g,
    telephoneWithMinimum: /^\d{4,20}$/g,
    telephoneNoPlusSignal: /^\d{0,20}$/g,
    telephoneNoPlusSignal50: /^\d{0,50}$/g,
    telephoneNoPlusSignal100: /^\d{0,100}$/g,
    telephoneNoPlusSignal255: /^\d{0,255}$/g,
    email: /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,25})$/g,
    date: /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d{4}$/g,
    dateInternal: /^\d{4}-(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])$/g,
    iban: /^([a-zA-Z]{2}[0-9]{2})([a-zA-Z0-9]{9,30})$/g,
    website: /^(http(s?):\/\/www|www)\.[-a-zA-Z0-9]{2,63}\.([a-z]{2,63}\.[a-z]{2,63}|[a-z]{2,63})$/g,
    alphaNumericUpperCase: /^[a-zA-Z0-9]+$/g,
  },
}

export default globalConfig
